import Common from './Common.js';
import MouseWheel from './MouseWheel.js';

const singleton = Symbol();
const singletonEnforcer = Symbol();

class Navigation {

    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw "Cannot construct singleton"
        }

        this.comm = Common.instance;
        this.mw = MouseWheel.instance;
        this.callbackFnList = [];
    }

    static get instance() {
        if(!this[singleton]) {
            this[singleton] = new Navigation(singletonEnforcer);
        }
        return this[singleton];
    }

    urlExtract(){
        let hashStr = location.hash.replace('#', '').split('/')[0];
        let depth = {d1: 1, d2: 1, anchor: this.comm.sectionList[0].anchorStr(1, 1)};

        this.comm.mainContainer.find( '.scr-v > section').each((idxD1, item)=>{
            $(item).find( '.scr-h > article').each((idxD2, itema)=>{
                let articleItem = $(itema);
                if( articleItem.data('anchor') == hashStr ){
                    depth = {d1: idxD1+1, d2: idxD2+1, anchor: articleItem.data('anchor')};
                    return;
                }
            });
        });

        this.update(depth.d1, depth.d2, depth.anchor);
    }

    /** start of Public   **/
    init(){
        this.mw.addCallback( _dir => this.nextprev(_dir) );
        $(window).on( 'hashchange', ev => this.urlExtract() ).trigger('hashchange');
    }

    addCallback(_fn){
        this.callbackFnList.push(_fn);
    }

    update(_d1 = this.comm.depth.d1, _d2 = this.comm.depth.d2, _anchor){
        if(_d1<1) _d1 = 1;
        if(_d1>this.comm.sectionList.length) _d1 = this.comm.sectionList.length;

        if(_d2<1) _d2 = 1;
        if(_d2>this.comm.sectionList[_d1-1].articleLength) _d2 = this.comm.sectionList[_d1-1].articleLength;

        if(typeof this.comm.option.callBack =="function" && (this.comm.depth.d1 != _d1 || this.comm.depth.d2 != _d2)){
            this.comm.option.callBack( {d1: _d1, d2: _d2}, _anchor  );
        }
        this.callbackFnList.forEach( _fn => _fn( {d1: _d1, d2: _d2} ));
        this.comm.depth = { d1: _d1, d2: _d2 };
    }

    updateUp(_d2=1){
        this.go(this.comm.depth.d1-1, _d2);
    }

    updateDown(_d2=1){
        this.go(this.comm.depth.d1+1, _d2);
    }

    updateLeft(){
        this.go(this.comm.depth.d1, this.comm.depth.d2-1);
    }

    updateRight(){
        this.go(this.comm.depth.d1, this.comm.depth.d2+1);
    }

    go(_d1 = this.comm.depth.d1, _d2 = this.comm.depth.d2){
        if(_d1<1) _d1 = 1;
        if(_d1>this.comm.sectionList.length) _d1 = this.comm.sectionList.length;
        if(_d2<1) _d2 = 1;
        if(_d2>this.comm.sectionList[_d1-1].articleLength) _d2 = this.comm.sectionList[_d1-1].articleLength;

        if(this.comm.depth.d1 == _d1 && this.comm.depth.d2 == _d2){
            this.update(_d1, _d2, this.comm.sectionList[_d1-1].anchorStr(_d1, _d2));
        }else{
            let secItem = this.comm.sectionList[_d1-1];
            let anchorStr = secItem.anchorStr(_d1, _d2);
            if(anchorStr){
                location.href = '#' + anchorStr;
            }else{
                this.update(1, 1, this.comm.sectionList[0].anchorStr(1, 1));
            }
        }

    }

    nextprev(_dir){
        let secItem = this.comm.sectionList[this.comm.depth.d1-1];
        let artcleLeng = secItem.articleLength;

        if(_dir>0){
            if(this.comm.depth.d1 >= this.comm.sectionList.length && this.comm.depth.d2 >= artcleLeng){
                return;
            }
            if(this.comm.depth.d2 < artcleLeng){
                this.updateRight();
            } else {
                this.updateDown();
            }
        }else{
            if(this.comm.depth.d2 > 1){
                this.updateLeft();
            } else {
                secItem = this.comm.sectionList[this.comm.depth.d1-2];
                artcleLeng = secItem? secItem.articleLength: 1;
                this.updateUp( artcleLeng );
            }
        }
    }

    /** end of Public  **/

}

export default Navigation;


// WEBPACK FOOTER //
// ./Navigation.js